// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root___tLfE","errors":"Errors_errors__dDFz4"};